/* eslint-disable react-hooks/exhaustive-deps */
import Image from "next/image";
import { BRAND_NAME } from "@/utils/constants";

import { GA4_ITEM_BRAND } from "@/lib/ga4";
import Link from "next/link";

import PageNotFound from "@/components/common/page-not-found/page-not-found";
import Trending_Design from "@/components/home/trending_design";
import ProductDetailsBreadcrumbs from "@/components/product-details/breadcrumb/breadcrumb";
import ProductDetailsCertificate from "@/components/product-details/certificate/certificate";
import ProductDetailsDelivery from "@/components/product-details/delivery/delivery";
import ProductDetailsDiscount from "@/components/product-details/discount-detail/discount";
import ProductDetailsFilter from "@/components/product-details/filter/filter";
import ProductDetailsFivestar from "@/components/product-details/fivestar/fivestar";
import ProductDetailsPrice from "@/components/product-details/price/price";
import ProductDetailsPurchase from "@/components/product-details/purchase/purchase";
import ProductDetailsSimilar from "@/components/product-details/similar/similar";
import ProductDetailsSlider from "@/components/product-details/slider/slider";
import ProductDetailsTab from "@/components/product-details/tab/tab";
import ProductDetailsTitle from "@/components/product-details/title/title";
import ProductDetailsMadeInIndiaShare from "@/components/product-details/made-in-india-share/made-in-india-share";
import ProductDetailsRatingBadge from "@/components/product-details/rating-badge/rating-badge";
import { Modal } from "react-bootstrap";
import bis from "../../../assets/images/bisnew.png";
import sgl from "../../../assets/images/sglnew.png";
import Layout from "@/layout/layout";
import { fbqTrackEvent } from "@/lib/fpixel";
import { wrapper } from "@/store";
import {
  selectHelmet,
  setIgnoreCommonTitle,
  setMeta,
  setOg,
  setPath,
  setSchemas,
  setTitle,
} from "@/store/slices/helmet";
import { fetchProductBySlug, selectProduct } from "@/store/slices/product";
import Script from "next/script";
import React, { ReactElement, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styles from "./productDetails.module.scss";
import { selectAuth } from "@/store/slices/auth";
import { syteTrackEvent } from "@/lib/syte";
import RatingProduct from "@/components/product-details/rating/ratingProduct";
import ProductFrequentlyBrought from "@/components/product-details/frequentlyBrought/frequentlyBrought";
import httpClient from "@/api/http-client";
import endpoints from "@/api/endpoints";
import { getCookie } from "cookies-next";
import { unbxdCusEngTrackEvent } from "@/lib/unbxd";
import FindStore from "@/components/product-details/find-store/find-store";

const Product = () => {
  const productState = useSelector(selectProduct);
  const helmetState = useSelector(selectHelmet);
  const authState = useSelector(selectAuth);
  const [product, setProduct] = useState<any>([]);

  useEffect(() => {
    setTimeout(() => {
      if (window.Moengage) {
        window.Moengage.track_event("Product Viewed", {
          name: productState.data?.title,
          id: productState.data?.sku,
          category:
            productState.data?.categories &&
            productState.data?.categories.length
              ? [...productState.data?.categories].reverse()[0].name
              : "",
          sellingPrice:
            productState.selectedPrice?.discount?.price ||
            productState.selectedPrice?.total,
          stockAvailability: "yes",
          recentlyViews: authState.user?.name || "",
        });
      }
        unbxdCusEngTrackEvent("Product View", {
          source: "web",
          platform: "senco",
          prid: productState.data?.id,
          variant_id: productState.selectedPrice?.id,
          image: productState.data?.images[0].media,
          prqt: 1,
          product_name: productState.data?.title,
          category: productState.data?.categories?.length
            ? [...productState.data.categories].reverse()[0]?.name
            : "",
          brand: BRAND_NAME,
          amount: productState.data?.prices[0].total,
          product_url: `${window.location.origin}/products/${productState.data?.slug}`,
          discounted_price: productState.selectedPrice?.discount?.price || 0,
          stock_availability: productState.data?.stock ? 1 : 0,
        });
    }, 500);
  }, [productState.data, productState.selectedPrice, authState]);
  useEffect(() => {
    unbxdProduct();
  }, []);

  const unbxdProduct = async () => {
    const data = await httpClient.get(endpoints.unbxd(), {
      params: {
        pageType: "PRODUCT",
        uid: getCookie("unbxd.userId"),
        id: productState.data?.sku,
      },
    });
    setProduct(data);
  };

  useEffect(() => {
    if (!productState.data) return;

    fbqTrackEvent("ViewContent", {
      content_type: "product",
      content_ids: [productState.data?.sku],
    });

    if (productState.data.categories && productState.data.categories.length) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: "INR",
          value:
            productState.selectedPrice?.discount?.price ||
            productState.selectedPrice?.total,
          items: [
            {
              item_id: productState.data.sku,
              item_name: productState.data.title,
              item_brand: GA4_ITEM_BRAND,
              item_category: [...productState.data.categories].reverse()[0]
                .name,
              item_variant: productState.selectedPrice?.purity,
              price:
                productState.selectedPrice?.discount?.price ||
                productState.selectedPrice?.total,
            },
          ],
        },
      });
      window.gtag(
        "event",
        !!productState.data.try_online
          ? "page-view-with-tryon-button"
          : "page-view-without-tryon-button",
        {
          event_category: "mirrar-internal-event",
          event_label: `${
            [...productState.data.categories].reverse()[0].name
          }/${productState.data.sku}`,
        }
      );
    }

    if (!authState.isUserLoading) {
      syteTrackEvent({
        name: "fe_page_view",
        tag: "ecommerce",
        osh_id: authState.user?.uuid,
        sku: productState.data?.sku,
      });
    }

    let data: any = [];
    try {
      if (localStorage.getItem("recentViews")) {
        data = JSON.parse(localStorage.getItem("recentViews") || "[]");
      }
    } catch (error) {}

    if (!data.includes(productState.data.slug)) {
      data = [productState.data.slug, ...data];
    }
    while (data.length > 10) {
      data.pop();
    }
    localStorage.setItem("recentViews", JSON.stringify(data));
  }, [
    authState.isUserLoading,
    authState.user?.uuid,
    productState.data,
    productState.selectedPrice,
  ]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="w-100">
        <ProductDetailsBreadcrumbs />
      </div>
      <div className={`${styles.container} ${"container"}`}>
        <div className="row">
          <div className="col-lg-6">
            <div className={styles.product_details_image}>
              <ProductDetailsSlider />
            </div>
          </div>
          <div className="col-lg-6">
            {/* <ProductDetailsRating /> */}
            <div className={styles.product_content}>
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex flex-wrap align-items-center">
                    <ProductDetailsMadeInIndiaShare />
                    <ProductDetailsRatingBadge />
                    <ProductDetailsPrice />
                  </div>
                  <div className={styles.mrp_text}>
                    (MRP Inclusive of all taxes)
                  </div>
                  <ProductDetailsDiscount />
                </div>
                {/* <div className="col-md-5">
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.bis.bisapp"
                    passHref
                  >
                    <div className={styles.mark_h}>
                      <Image
                        src="https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/XIijKO0NEOAb9RKA8cJ9IqPAIUzqtP5SgLcp32Dt.png"
                        alt="BIS CARE"
                        width="100px"
                        height="80px"
                        layout="fill"
                      />
                    </div>
                  </Link>
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.bis.bisapp"
                    passHref
                  >
                    <div className={styles.biscareapp}>
                      Click here to download the <br /> BIS Care App
                    </div>
                  </Link>
                </div> */}
              </div>
              <ProductDetailsTitle />

              <ProductDetailsFilter />

              <ProductDetailsDelivery />
              <ProductDetailsPurchase />

              {/* <div className={styles.book_appointment}></div> */}
              {/* <ProductDetailsBooking /> */}
              <div className="row ">
                <div className="col-md-5">
                  <div className={styles.link_all}>
                    <Link
                      href="https://play.google.com/store/search?q=bis+care+app&c=apps"
                      passHref
                    >
                      <div className={styles.mark_h}>
                        <Image src={bis} alt="BIS Care App"/>
                      </div>
                    </Link>
                    <Link
                      href="https://play.google.com/store/search?q=bis+care+app&c=apps"
                      passHref
                    >
                      <div className={styles.biscareapp}>
                        Click here to download the BIS Care App
                      </div>
                    </Link>
                  </div>
                </div>

                {/* <ProductDetailsDiscount /> */}
                {/* <ProductDetailsPrice /> */}
                {!!productState.selectedPrice?.diamond_weight && (
                  <>
                    <div className="col-md-7">
                      <div className={styles.link_all}>
                        <div className={styles.sgl}>
                          <div className={styles.sgl_image}>
                            <Image src={sgl} alt="SGL"/>
                          </div>
                        </div>
                        <div className={styles.view}>
                          <p className="ps-1">
                            Certified Diamond Jewellery To view sample
                            certificate
                            <a onClick={() => setShow(true)}>( Click Here )</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <Modal show={show} onHide={handleClose} centered size="lg">
                  <Image
                    src={require("@/assets/images/SGL-CRT.jpg")}
                    alt="Sample certificate"
                    priority
                  />
                </Modal>

                <div className="col-md-7 text-md-end">
                  <div className="w-100">
                    <div className={styles.badge}>
                      <div className={styles.icon}>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M29.9998 15.0001C29.9998 14.8479 29.9356 14.7027 29.8228 14.6005L27.5163 12.5094L28.8502 9.69569C28.9154 9.5579 28.9194 9.39896 28.8611 9.25819C28.8027 9.11737 28.6875 9.00778 28.5439 8.9566L25.6106 7.91133L25.7638 4.80141C25.7713 4.64932 25.7142 4.50117 25.6065 4.39346C25.4988 4.28581 25.3503 4.22924 25.1986 4.23614L22.0886 4.38931L21.0434 1.45608C20.9922 1.31245 20.8827 1.1972 20.7419 1.13884C20.6011 1.08049 20.4421 1.08442 20.3044 1.14974L17.4907 2.4836L15.3994 0.177062C15.2972 0.0642888 15.1521 0 14.9999 0C14.8477 0 14.7026 0.0642888 14.6004 0.177062L12.5091 2.4836L9.69548 1.14968C9.55779 1.08443 9.3988 1.08038 9.25798 1.13879C9.11716 1.19714 9.00757 1.3124 8.95644 1.45602L7.91123 4.38926L4.80133 4.23609C4.64859 4.22859 4.50109 4.28571 4.39344 4.39341C4.28579 4.50106 4.22862 4.64921 4.23612 4.80136L4.38923 7.91128L1.45596 8.95655C1.31234 9.00773 1.19714 9.11727 1.13873 9.25814C1.08037 9.3989 1.08431 9.5579 1.14962 9.69564L2.48359 12.5093L0.17706 14.6005C0.0642869 14.7028 0 14.8479 0 15.0001C0 15.1523 0.0642869 15.2974 0.17706 15.3996L2.48359 17.4908L1.14968 20.3045C1.08436 20.4423 1.08043 20.6012 1.13878 20.742C1.19714 20.8828 1.31239 20.9924 1.45596 21.0436L4.38918 22.0888L4.23601 25.1987C4.22852 25.3508 4.28563 25.4989 4.39333 25.6066C4.50098 25.7142 4.64854 25.771 4.80122 25.7639L7.91113 25.6108L8.95634 28.544C9.00752 28.6877 9.11706 28.8029 9.25787 28.8613C9.39864 28.9196 9.55763 28.9157 9.69537 28.8504L12.5091 27.5165L14.6003 29.823C14.7026 29.9358 14.8476 30.0001 14.9998 30.0001C15.152 30.0001 15.2972 29.9358 15.3994 29.823L17.4906 27.5165L20.3043 28.8504C20.4419 28.9157 20.6009 28.9197 20.7418 28.8613C20.8826 28.8029 20.9922 28.6877 21.0433 28.544L22.0885 25.6108L25.1984 25.764C25.3507 25.771 25.4986 25.7143 25.6063 25.6066C25.714 25.499 25.7711 25.3508 25.7636 25.1987L25.6105 22.0888L28.5438 21.0436C28.6874 20.9924 28.8026 20.8828 28.861 20.742C28.9194 20.6012 28.9154 20.4422 28.8501 20.3045L27.5161 17.4907L29.8227 15.3996C29.9356 15.2974 29.9998 15.1523 29.9998 15.0001ZM14.9999 26.0184C8.91476 26.0184 3.98167 21.0854 3.98167 15.0001C3.98167 8.9148 8.9147 3.9818 14.9999 3.9818C21.0852 3.9818 26.0182 8.91486 26.0182 15.0001C26.0182 21.0854 21.0851 26.0184 14.9999 26.0184Z"
                            fill="#8F0006"
                          />
                          <path
                            d="M14.9988 26.2869C8.77465 26.2869 3.71094 21.2231 3.71094 14.9989C3.71094 8.77468 8.77465 3.71094 14.9988 3.71094C21.223 3.71094 26.2868 8.77473 26.2868 14.9989C26.2868 21.2231 21.223 26.2869 14.9988 26.2869ZM14.9988 4.25026C9.07203 4.25026 4.25026 9.07206 4.25026 14.9989C4.25026 20.9258 9.07203 25.7476 14.9988 25.7476C20.9256 25.7476 25.7474 20.9258 25.7474 14.9989C25.7474 9.07201 20.9256 4.25026 14.9988 4.25026Z"
                            fill="#ECA100"
                          />
                          <path
                            d="M15.386 7.50781L17.2477 13.2372H23.2721L18.3982 16.7784L20.2598 22.5078L15.386 18.9668L10.5123 22.5078L12.3739 16.7784L7.5 13.2372H13.5244L15.386 7.50781Z"
                            fill="#D18F00"
                          />
                        </svg>
                      </div>

                      <div className={styles.text}>
                        <strong>100% Certified</strong>
                        <span className={styles.separator}>•</span>
                        <span>Lifetime Exchange @store</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ProductDetailsTab />
              <div className={styles.product_certificate_mobile}>
                <ProductDetailsCertificate />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.product_certificate_desktop}>
        <div className={`${styles.container} ${"container"}`}>
          <div className="row">
            <ProductDetailsCertificate />
          </div>
        </div>
      </div>
      <ProductDetailsFivestar />
      {/* <ProductDetailsComment /> */}
      {/* <hr /> */}
      <div className={`${styles.container} ${"container"}`}>
        {!!Object.keys(product).length && (
          <>
            <ProductDetailsSimilar product={product} />
            <ProductFrequentlyBrought product={product} />
            <Trending_Design product={product} pagetype="PRODUCT" />
          </>
        )}
      </div>
      <RatingProduct />
    </>
  );
};

Product.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ params, resolvedUrl }) => {
      if (!params?.slug) {
        return { props: {} };
      }
      store.dispatch(setPath(resolvedUrl));
      const { payload: product } = await store.dispatch(
        fetchProductBySlug(params.slug as string)
      );
      if (!product) {
        return { notFound: true };
      }

      const defaultPrice = product.prices.find(
        (p: any) => p.id == product.defaultPriceId
      );
      const selectedPrice = defaultPrice || product.prices[0];
      const sellingPrice = selectedPrice.discount?.price || selectedPrice.total;
      const defaultMetaTitle = `${product.title} - ₹${sellingPrice}, Buy ${product.title} Online - Senco Gold and Diamonds `;
      const defaultMetaDescription = `${product.title} - ${product.description}`;

      store.dispatch(setTitle(product.meta_title || defaultMetaTitle));
      store.dispatch(
        setMeta({
          title: product.meta_title || defaultMetaTitle,
          description: product.meta_description || defaultMetaDescription,
          keywords: product.meta_keywords,
        })
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: product.meta_title || defaultMetaTitle,
          description: product.meta_description || defaultMetaDescription,
          image: product.images.length ? product.images[0].media : "",
        })
      );
      if (product.title) store.dispatch(setIgnoreCommonTitle(true));
      try {
        const existingSchemas = [
          JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "Product",
            name: product.meta_title || defaultMetaTitle,
            description: product.meta_description || defaultMetaDescription,
            sku: product.sku,
            brand: {
              "@type": "Thing",
              name: "Senco Gold",
            },
            image: product.images.map((v: any) => v.media),
            offers: {
              url: {},
              "@type": "Offer",
              priceCurrency: "INR",
              price: sellingPrice,
              availability: "http://schema.org/InStock",
            },
          }),
        ];

        if (product.schema) {
          existingSchemas.push(
            typeof product.schema === "string"
              ? product.schema
              : JSON.stringify(product.schema)
          );
        }

        const metaTitle = product.meta_title || defaultMetaTitle;
        const metaDescription = product.meta_description || defaultMetaDescription;
        const h1Text = product.title || "";

        const speakableSchemaObj = {
          "@context": "https://schema.org",
          "@type": "SpeakableSpecification",
          "cssSelector": [
            `"metaTitle": "${metaTitle}"`,
            `"metaDescription": "${metaDescription}"`,
            `"H1": "${h1Text}"`,
          ],
        };

        const speakableSchemaStr = JSON.stringify(speakableSchemaObj);
        store.dispatch(setSchemas([...existingSchemas, speakableSchemaStr]));
      } catch (error) {}

      return {
        props: {},
      };
    }
);

export default Product;
